"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_UPDATE = exports.SDK_READY_FROM_CACHE = exports.SDK_READY = exports.SDK_READY_TIMED_OUT = exports.SDK_SEGMENTS_ARRIVED = exports.SDK_SPLITS_CACHE_LOADED = exports.SDK_SPLITS_ARRIVED = void 0;
// Splits events:
exports.SDK_SPLITS_ARRIVED = 'state::splits-arrived';
exports.SDK_SPLITS_CACHE_LOADED = 'state::splits-cache-loaded';
// Segments events:
exports.SDK_SEGMENTS_ARRIVED = 'state::segments-arrived';
// Readiness events:
exports.SDK_READY_TIMED_OUT = 'init::timeout';
exports.SDK_READY = 'init::ready';
exports.SDK_READY_FROM_CACHE = 'init::cache-ready';
exports.SDK_UPDATE = 'state::update';
